/* eslint-disable max-len */
import { SvgIcon, SvgIconProps } from '@mui/material';

export default function CardViewIcon(props: SvgIconProps) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path d="M4 11.3333V4H11.3333V11.3333H4ZM4 20V12.6667H11.3333V20H4ZM12.6667 11.3333V4H20V11.3333H12.6667ZM12.6667 20V12.6667H20V20H12.6667ZM2.66667 24C1.93333 24 1.30556 23.7389 0.783333 23.2167C0.261111 22.6944 0 22.0667 0 21.3333V2.66667C0 1.93333 0.261111 1.30556 0.783333 0.783333C1.30556 0.261111 1.93333 0 2.66667 0H21.3333C22.0667 0 22.6944 0.261111 23.2167 0.783333C23.7389 1.30556 24 1.93333 24 2.66667V21.3333C24 22.0667 23.7389 22.6944 23.2167 23.2167C22.6944 23.7389 22.0667 24 21.3333 24H2.66667ZM2.66667 21.3333H21.3333V2.66667H2.66667V21.3333Z" fill="currentColor"/>
    </SvgIcon>
  );
}
